import Vue from 'vue'
// 组合widgets目录下，所有挂件的style文件，合并成一个大对象
const files = require.context('../views/costPlatform/components/widgets', true, /\.(vue|js)$/)
const styles = {}
files.keys().forEach((key) => {
  // style.js文件的处理
  if (key.indexOf('/style.js') > -1) {
    const obj = get_file(key)
    if (obj && obj.default) {
      const new_obj = JSON.parse(JSON.stringify(obj.default))
      styles[obj.default.cmpType] = new_obj
    }
  }

  // widgets文件下的index.vue（预览显示）组件注册
  if (key.indexOf('/index.vue') > -1 && key.indexOf('/basic_') > -1) {
    
    const obj = get_file(key)
    const name = key.replace('./basic_', '').replace('/index.vue', '_index')
    Vue.component(name, obj.default)
  }

  // widgets文件下的edit.vue（编辑端）组件注册
  if (key.indexOf('/edit.vue') > -1 && key.indexOf('/basic_') > -1) {
    
    const obj = get_file(key)
    const name = key.replace('./basic_', '').replace('/edit.vue', '_edit')
    Vue.component(name, obj.default)
  }

  // widgets文件下的material.vue（左侧挂件素材）组件注册
  if (key.indexOf('/material.vue') > -1 && key.indexOf('/basic_') > -1) {
    
    const obj = get_file(key)
    const name = key.replace('./basic_', '').replace('/material.vue', '_material')
    
    Vue.component(name, obj.default)
  }
})

function get_file(key) {
  const src = key.replace('./', '')
  const obj = require(`../views/costPlatform/components/widgets/${src}`)
  return obj
}

// 所有挂件默认样式，打成一个大对象，新增挂件时读取
export default styles
